import React from "react";
import { View } from 'react-native'
import _ from 'lodash'
import Text from "theme/Text";
import { ThemedItemStyles } from 'styles/components/atoms/ThemedItem'
import isEqual from 'react-fast-compare'
import HelperString from 'utils/helper-string'

const ThemedItem = ( { identifier = null, accessoryLeft = null, accessoryLeftSize = 60, accessoryLeftHeightSizing = 'height', forceAccessoryLeftContainer = false, title = null, subtitle = null, items = [], actionItem = null, style = {}, titleStyle = {}, children = null, testID = null } ) => {
	
	const viewStyle = [
		ThemedItemStyles.container,
		style
	]
	
	const accessoryLeftViewStyle = [
		ThemedItemStyles.accessoryLeftContainer,
		{
			width: accessoryLeftSize,
			[ accessoryLeftHeightSizing ]: accessoryLeftSize
		}
	]
	
	const titleViewStyle = [
		ThemedItemStyles.contentTitle,
		titleStyle
	]
	
	let accessoryLeftView = null;
	if( accessoryLeft !== null || forceAccessoryLeftContainer ) {
		accessoryLeftView = (
			<View
				style={ accessoryLeftViewStyle }>
				
				{ accessoryLeft }
			</View>
		)
	}
	
	let titleView = null;
	if( !_.isEmpty( title ) ) {
		titleView = (
			<Text
				style={ titleViewStyle }>
				
				{ title }
			</Text>
		)
	}
	
	let subtitleView = null;
	if( !_.isEmpty( subtitle ) ) {
		subtitleView = (
			<Text style={ ThemedItemStyles.contentSubTitle }>
				{ subtitle }
			</Text>
		)
	}
	
	let itemsView = null;
	if( !_.isEmpty( items ) ) {
		itemsView = (
			<View
				style={ ThemedItemStyles.items }>
				
				{ items }
			</View>
		)
	}
	
	let actionItemsView = null
	if( !_.isEmpty( actionItem ) ) {
		
		const actionItemView = _.map( _.isArray( actionItem ) ? actionItem : [ actionItem ], (o, kk) => {
			return (
				<View
					key={ HelperString.hash('external', kk ) }
					style={ ThemedItemStyles.actionItemView }>

					{ o }
				</View>
			);
		} )
		
		actionItemsView = (
			<View
				style={ ThemedItemStyles.actionItemContainer }>
				
				{ actionItemView }
			</View>
		)
	}
	
	return (
		<View
			key={ identifier }
			style={ viewStyle }
			testID={ testID }>
			
			{ accessoryLeftView }
			
			<View
				style={ ThemedItemStyles.contentContainer }>
				
				{ titleView }
				
				{ subtitleView }
				
				{ itemsView }
				
				{ children }
			</View>
			
			{ actionItemsView }
		</View>
	);
}

export default React.memo( ThemedItem, isEqual );
